import { useTheme } from 'styled-components';
import ArrowIconBold from './ArrowIconBold';
import ArrowIconSlim from './ArrowIconSlim';

/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @param {number | undefined} [props.height]
 * @param {number | undefined} [props.width]
 * @returns {React.ReactElement} The rendered component
 */
const ArrowCTAIcon = ({ className, height, width }) => {
  const theme = useTheme();
  const type = theme.arrowType;
  if (type === 'bold') {
    return (
      <ArrowIconBold
        className={className}
        height={height}
        width={width}
        data-id="arrow-cta-icon-bold"
      />
    );
  }
  return (
    <ArrowIconSlim
      className={className}
      height={height}
      width={width}
      data-id="arrow-cta-icon-slim"
    />
  );
};

export default ArrowCTAIcon;
